import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../DataTable";
import Loading from "../Loading";
import { useOrderList } from "./Hooks/GeneralHook";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";
import { itemFinancialUserList } from "../../../../Utils/orderListRoutes";
import { sepJustMoney } from "../../Function";
import BoxShadow from "../BoxShadow";

const OrderList = ({ role = false, short = false }) => {
  const { user } = useSelector(state => state);
  const {
    data,
    data2,
    loading,
    getData,
    searchHandler,
    pageHandler,
    sortHandler,
    filter,
  } = useOrderList(role);
  useEffect(() => {
    getData();
  }, []);
  const navigate = useNavigate();

  const multiSearchData = [
    { fn: searchHandler, label: "جستجو بر اساس نام، تلفن، کد پیگیری", size: "col-md-5" },
    { fn: searchHandler, label: "نوع سفارش (تکی، قراردادی، اقساطی)", size: "col-md-4" },
    { fn: searchHandler, label: "نوع پرداخت (آنلاین، در محل)", size: "col-md-3" },
  ]

  const renderLinks = () => {
    switch (user.role) {
      case "owner":
      case "supporter":
      case "financial":
      case "contentmaker":
      case "user":
        return [
          {
            function: selected => {
              navigate(
                Checkroutedeatils() +
                data.data.filter(order => order.id == selected[0])[0]
                  .trackingcodeorder
              );
            },
            color: "warning text-white",
            size: "col-md-2",
            html: "جزییات",
            // main: true,
            type: "show",
          },
          {
            size: "col-6",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">نوع سفارش</InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler("model_order", e.target.value);
                  }}
                  label={"مرتب شدن بر اساس"}
                  selected={filter["model_order"]}
                >
                  <MenuItem value={"reserve"}>رزرواسیون</MenuItem>
                  <MenuItem value={"joinclass"}>خرید کلاس</MenuItem>
                  <MenuItem value={"walletsharge"}>شارژ کیف پول</MenuItem>
                  <MenuItem value={"contractual_reservation"}>
                    رزرو قراردادی
                  </MenuItem>
                  <MenuItem value={"contractual_reservation_installments"}>
                    رزرو قراردادی پرداخت ماهیانه
                  </MenuItem>
                </Select>
              </FormControl>
            ),
          },
          {
            size: "col-6",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">
                  نوع پرداخت
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler("type_payment", e.target.value);
                  }}
                  label={"مرتب شدن بر اساس"}
                  selected={filter["type_payment"]}
                >
                  <MenuItem value={"gateway"}>آنلاین</MenuItem>
                  <MenuItem value={"wallet"}>کیف پول</MenuItem>
                  <MenuItem value={"others"}>پرداخت نقدی</MenuItem>
                </Select>
              </FormControl>
            ),
          },
        ];
      default:
        return [
          {
            function: selected => {
              navigate(
                Checkroutedeatils() +
                data.data.filter(order => order.id == selected[0])[0]
                  .trackingcodeorder,
                { state: { role } }
              );
            },
            color: "warning text-white",
            size: "col-md-2",
            html: "جزییات",
            main: true,
            type: "show",
          },

          {
            size: "col-12 col-md-4",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">
                  نوع پرداخت
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler("type_payment", e.target.value);
                  }}
                  label={"مرتب شدن بر اساس"}
                  selected={filter["type_payment"]}
                >
                  <MenuItem value={"gateway"}>آنلاین</MenuItem>
                  <MenuItem value={"wallet"}>کیف پول</MenuItem>
                  <MenuItem value={"others"}>پرداخت نقدی</MenuItem>
                </Select>
              </FormControl>
            ),
          },
        ];
    }
  };
  const Checkroutedeatils = () => {
    switch (user.role) {
      case "owner":
      case "supporter":
      case "financial":
      case "contentmaker":
        return "/Admin/OrderDetails/";
      default:
        return "/User/OrderDetails/";
    }
  };
  return (
    <div>

      <BoxShadow style={{ padding: "0px", marginBottom: "20px" }}>
        <table className="table table-hover text-center" style={{ overflowX: "scroll", pointerEvents: "none" }}>
          <thead className="thead-primary table-gradiant " style={{ color: "rgb(255, 255, 255)" }}>
            <tr>
              <th>جمع کل</th>
              <th>پرداختی ها </th>
              <th>لغو شده ها </th>
              <th>باقی مانده</th>
              <th>وضعیت</th>
            </tr>
          </thead>
          <tbody className="thead-primary table-gradiant " >
            <tr>
              <td>{sepJustMoney(data?.totalFinancial)}</td>
              <td>{sepJustMoney(data?.totalDoneWithdraw)}</td>
              <td>{sepJustMoney(data?.totalRefuneOrders)}</td>
              <td style={{ direction: "ltr" }}>{sepJustMoney(data?.partnerWalletAmount)}</td>
              <td>{data?.financialStatus} </td>
            </tr>

          </tbody>
        </table>
      </BoxShadow>
      {data2 &&
        <div className="row">
          <DataTable
            loading={loading.list}
            heads={itemFinancialUserList}
            list={data2 && data2.data}
            data={data2}
            textEmpty="سفارشی یافت نشد"
            search={multiSearchData}
            multiSearch={true}
            function={pageHandler}
            short={short}
            header="صورت حساب کلی"
          />
        </div>
      }
    </div>
  );
};

export default OrderList;